import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  email: null,
  refreshToken: null,
  accessToken: null,
  deviceToken: null,
  deviceExp: null,
  impersonationEmail: null,
  impersonationUser: null,
  impersonationToken: null,
  impersonationRefreshToken: null,
  impersonationDeviceToken: null,
  impersonationDeviceExp: null,
  impersonationDeviceEmail: null,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => ({
      ...state,
      email: action.payload.email,
      user: action.payload.user,
      refreshToken: action.payload.refreshToken,
      accessToken: action.payload.accessToken,
    }),
    setDeviceToken: (state, action) => ({
      ...state,
      deviceEmail: action.payload.deviceEmail,
      deviceToken: action.payload.deviceToken,
      deviceExp: action.payload.exp,
    }),
    clearDeviceToken: (state, action) => ({
      ...state,
      deviceEmail: null,
      deviceToken: null,
      deviceExp: null,
    }),
    logout: (state, action) => ({
      ...initialState,
      deviceEmail: action?.payload?.email || state.email,
      deviceToken: state.deviceToken,
      deviceExp: state.deviceExp,
    }),
    // impersonate another user (for admins)
    startImpersonation: (state, action) => ({
      ...state,
      ...(state.impersonationEmail 
        // if the user is already impersonating, simply switch the user
        ? {
          email: action.payload.email,
          user: action.payload.user,
          refreshToken: action.payload.refreshToken,
          accessToken: action.payload.accessToken,
          deviceToken: action.payload.deviceToken,
          deviceExp: action.payload.deviceExp,
          deviceEmail: action.payload.email,
        } 
        // start a new impersonation session
        : {
          impersonationEmail: state.email,
          impersonationUser: state.user,
          impersonationToken: state.accessToken,
          impersonationRefreshToken: state.refreshToken,
          impersonationDeviceToken: state.deviceToken,
          impersonationDeviceExp: state.deviceExp,
          impersonationDeviceEmail: state.deviceEmail,
          email: action.payload.email,
          user: action.payload.user,
          refreshToken: action.payload.refreshToken,
          accessToken: action.payload.accessToken,
          deviceToken: action.payload.deviceToken,
          deviceExp: action.payload.deviceExp,
          deviceEmail: action.payload.email,
        }
      ),
    }),
    // stop impersonating another user (for admins)
    stopImpersonation: (state, action) => ({
      ...state,
    }),
    // reset impersonation state
    clearImpersonation: (state, action) => ({
      ...state,
      impersonationEmail: null,
      impersonationUser: null,
      impersonationToken: null,
      impersonationRefreshToken: null,
      impersonationDeviceToken: null,
      impersonationDeviceExp: null,
      impersonationDeviceEmail: null,
    }),
  },
});

export const {
  setCredentials,
  setDeviceToken,
  logout,
  clearDeviceToken,
  startImpersonation,
  stopImpersonation,
  clearImpersonation,
} = slice.actions;

export default slice.reducer;
